<div class="config-list">
  <lib-pdf-ai-parser-nav></lib-pdf-ai-parser-nav>
  <div class="list-header">
    <div class="list-heading">
      <h3>{{ 'AI_PARSER_CONFIGS_TITLE' | translate }}</h3>
      <p class="list-caption">{{ 'AI_PARSER_CONFIGS_DESCRIPTION' | translate }}</p>
    </div>
    <button type="button" class="btn btn-primary" (click)="create()">
      <i class="fal fa-plus"></i> {{ 'AI_PARSER_CONFIG_NEW' | translate }}
    </button>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage | translate }}</div>

  <div *ngIf="loading" class="config-rows">
    <div class="config-row config-row-skeleton" *ngFor="let placeholder of [1, 2]">
      <div class="config-body">
        <span class="skeleton skeleton-title"></span>
        <div class="meta-grid">
          <span class="skeleton skeleton-meta"></span>
          <span class="skeleton skeleton-meta"></span>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <div *ngIf="configs.length === 0" class="list-empty">
      <i class="fas fa-sliders-h list-empty-icon"></i>
      <p class="list-empty-title">{{ 'AI_PARSER_CONFIGS_EMPTY' | translate }}</p>
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="create()">
        <i class="fal fa-plus"></i> {{ 'AI_PARSER_CONFIG_NEW' | translate }}
      </button>
    </div>

    <div *ngIf="configs.length > 0" class="config-toolbar-row">
      <div class="search-box">
        <i class="fas fa-search search-icon"></i>
        <input
          type="text"
          class="form-control search-input"
          [(ngModel)]="searchTerm"
          name="searchTerm"
          [placeholder]="'AI_PARSER_CONFIG_SEARCH_PLACEHOLDER' | translate"
          autocomplete="off" />
        <button *ngIf="searchTerm" type="button" class="search-clear" (click)="searchTerm = ''" [attr.aria-label]="'CANCEL' | translate">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <select
        class="form-select config-page-size"
        [(ngModel)]="pageSize"
        name="pageSize"
        [attr.aria-label]="'DISPLAY_BATCH_PREFIX' | translate">
        <option *ngFor="let size of pageSizes" [ngValue]="size">
          {{ 'DISPLAY_BATCH_PREFIX' | translate }} {{ size }}
        </option>
      </select>
    </div>

    <p *ngIf="configs.length > 0" class="config-count">
      {{ searchTerm.trim() ? (visibleConfigs.length + ' / ' + configs.length) : configs.length }}
      {{ 'AI_PARSER_CONFIGS_COUNT' | translate }}
    </p>

    <p *ngIf="configs.length > 0 && visibleConfigs.length === 0" class="list-empty list-empty-compact">
      {{ 'AI_PARSER_CONFIGS_NO_MATCHES' | translate }}
    </p>

    <div class="config-rows">
      <div class="config-row" *ngFor="let config of pagedConfigs" (click)="edit(config)">
        <div class="config-body">
          <div class="config-top">
            <div class="config-heading">
              <span class="config-name" [class.config-name-missing]="!config.name">
                {{ config.name || ('AI_PARSER_CONFIG_UNNAMED' | translate) }}
              </span>
              <p *ngIf="config.aiInstructions" class="config-prompt">{{ promptPreview(config.aiInstructions) }}</p>
            </div>
            <div class="config-actions" (click)="$event.stopPropagation()">
              <button type="button" class="text-btn" (click)="edit(config)">
                <i class="fal fa-pen"></i><span>{{ 'EDIT' | translate }}</span>
              </button>
              <button type="button" class="text-btn text-btn-danger" (click)="askDelete(config)">
                <i class="fal fa-trash"></i><span>{{ 'DELETE' | translate }}</span>
              </button>
            </div>
          </div>

          <div class="meta-grid">
            <div class="meta-item" *ngIf="config.suggestedDeliveryCustomerId">
              <span class="meta-label">{{ 'AI_PARSER_CONFIG_DELIVERY_CUSTOMER' | translate }}</span>
              <span class="meta-value">
                <span class="meta-id">{{ config.suggestedDeliveryCustomerId }}</span>
                <span *ngIf="isResolvingCustomer(config.suggestedDeliveryCustomerId)" class="skeleton skeleton-name"></span>
                <span *ngIf="customerName(config.suggestedDeliveryCustomerId) as name" class="meta-name">{{ name }}</span>
                <span *ngIf="customerNotFound(config.suggestedDeliveryCustomerId)" class="meta-name meta-name-missing">{{ 'AI_PARSER_CONFIG_CUSTOMER_NOT_FOUND' | translate }}</span>
              </span>
            </div>

            <div class="meta-item" *ngIf="config.suggestedBillingCustomerId">
              <span class="meta-label">{{ 'AI_PARSER_CONFIG_BILLING_CUSTOMER' | translate }}</span>
              <span class="meta-value">
                <span class="meta-id">{{ config.suggestedBillingCustomerId }}</span>
                <span *ngIf="isResolvingCustomer(config.suggestedBillingCustomerId)" class="skeleton skeleton-name"></span>
                <span *ngIf="customerName(config.suggestedBillingCustomerId) as name" class="meta-name">{{ name }}</span>
                <span *ngIf="customerNotFound(config.suggestedBillingCustomerId)" class="meta-name meta-name-missing">{{ 'AI_PARSER_CONFIG_CUSTOMER_NOT_FOUND' | translate }}</span>
              </span>
            </div>

            <div class="meta-item" *ngIf="config.responsibleUsername">
              <span class="meta-label">{{ 'USER' | translate }}</span>
              <span class="meta-value">{{ config.responsibleUsername }}</span>
            </div>

            <div class="meta-item meta-item-wide" *ngIf="config.senderEmails?.length">
              <span class="meta-label">{{ 'AI_PARSER_CONFIG_SENDER_EMAILS' | translate }}</span>
              <span class="meta-value meta-chips">
                <span *ngFor="let email of config.senderEmails" class="meta-chip">{{ email }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #deleteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'AI_PARSER_CONFIG_DELETE_TITLE' | translate }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    {{ 'AI_PARSER_CONFIG_DELETE_CONFIRM' | translate:{ name: configToDelete?.name } }}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-danger" (click)="modal.close()">
      {{ 'DELETE' | translate }}
    </button>
  </div>
</ng-template>
